import { CURRENCY_OPTIONS, currencyLabel, type CurrencyCode } from '../lib/currency';
import { useCurrency } from './CurrencyProvider';

export function CurrencyToolbar({
  showDocumentToggle = true,
}: {
  showDocumentToggle?: boolean;
}) {
  const { documentCurrency, setDocumentCurrency } = useCurrency();

  if (!showDocumentToggle) {
    return null;
  }

  return (
    <div className="border-b border-stone-200/70 bg-stone-50/90 backdrop-blur-sm sticky top-16 z-[110] lg:grid lg:grid-cols-2">
      {/* Left side (matches form pane) */}
      <div className="py-2.5 px-4 md:px-6 lg:px-[40px] border-r-0 lg:border-r border-[#E7E5E4]">
        <div className="max-w-[540px] mx-auto w-full flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-[10px] font-bold uppercase tracking-wider text-stone-400">Document currency</span>
            <select
              value={documentCurrency}
              onChange={(e) => setDocumentCurrency(e.target.value as CurrencyCode)}
              className="h-7 px-2 pr-7 rounded-md border border-stone-200 bg-white shadow-sm text-xs font-semibold text-stone-700 appearance-none cursor-pointer hover:border-stone-300 transition-colors focus:ring-2 focus:ring-stone-200 focus:outline-none"
              style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2378716c' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 6px center' }}
            >
              {CURRENCY_OPTIONS.map((code) => (
                <option key={code} value={code}>
                  {currencyLabel(code)}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      {/* Right side (matches preview pane) */}
      <div className="hidden lg:block py-2 px-[40px] bg-[#F5F5F4]/50">
      </div>
    </div>
  );
}
